var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameTimeMobile = function SvgIconStorygameTimeMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.938a6 6 0 1 0 .001 12 6 6 0 0 0-.001-12Zm0 10.666a4.672 4.672 0 0 1-4.667-4.666A4.672 4.672 0 0 1 6 4.27a4.672 4.672 0 0 1 4.667 4.667A4.672 4.672 0 0 1 6 13.604Z",
    fill: "url(#icon-storygame-time-mobile_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 5.604H5.333v3.607l2.527 2.533.947-.946-2.14-2.134v-3.06Z",
    fill: "url(#icon-storygame-time-mobile_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.993 3.284v1.44a4.66 4.66 0 0 1 2.674 4.214 4.66 4.66 0 0 1-2.674 4.213v1.44C14.32 13.764 16 11.544 16 8.938c0-2.607-1.68-4.827-4.007-5.654Z",
    fill: "url(#icon-storygame-time-mobile_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-storygame-time-mobile_svg__a",
    x1: 16,
    y1: 2.938,
    x2: 10.088,
    y2: 18.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753BBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-storygame-time-mobile_svg__b",
    x1: 16,
    y1: 2.938,
    x2: 10.088,
    y2: 18.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753BBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-storygame-time-mobile_svg__c",
    x1: 16,
    y1: 2.938,
    x2: 10.088,
    y2: 18.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753BBD"
  })))));
};
export default SvgIconStorygameTimeMobile;